// extracted by mini-css-extract-plugin
export var container = "_fx-0";
export var segment = "_fx-2";
export var segmentActive = "_fx-3";
export var track = "_fx-1";